export const getInitials = (name: string): string => {
  if (!name) return '';
  const [firstName = '', lastName = ''] = name.split(' ');
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};
